export default "__VITE_ASSET__CAxENrZW__"